export default __webpack_public_path__ + "static/media/719660ee75461654316ff77bf1218eea1581601265494.6bc33cf6.webp";